import { Button, ButtonVariant } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { useMemo } from 'react'
import { useTransferContextProvider } from '../../context'
import { TransferSuccessTypes } from '../../types'

export const TransferSuccess: React.FC = () => {
  const { t } = useTranslation('features-transfer')

  const { displaySuccess, setDisplaySuccess } = useTransferContextProvider()

  function onClickHandler(): void {
    setDisplaySuccess(undefined)
  }

  // Only relevant for Bank | Investment Account Transfers
  const productName = useMemo(() => {
    if (!displaySuccess) return undefined
    return [
      TransferSuccessTypes.DepositMarketClosed,
      TransferSuccessTypes.DepositMarketOpen,
      TransferSuccessTypes.WithdrawMarketClosed,
      TransferSuccessTypes.WithdrawMarketOpen,
    ].includes(displaySuccess.successType)
      ? displaySuccess.toFieldOption.display.subtitle
      : undefined
  }, [displaySuccess])

  return displaySuccess ? (
    <>
      <CheckCircleIcon className="h-[3.5rem] w-[3.5rem] text-icons-feature-white stroke-[.5px] mb-sm" />
      <p className="typo-primary-xl-light text-text-header-success mb-md">{t('transfer.transfer_received')}</p>
      <p className="mb-md typo-primary-base-regular text-text-body">
        {t(`transfer.success_message.${displaySuccess.successType}`, { productName })}
      </p>
      <Button
        variant={ButtonVariant.Secondary}
        id="make-another-transfer"
        testId="make-another-transfer"
        className="max-md:w-full"
        onClick={onClickHandler}
      >
        {t('transfer.make_another_transfer')}
      </Button>
    </>
  ) : null
}
